<template>
  <div class="layout-framework-admin" :class="{ 'collapsed': navMenuObj.isCollapsed }"
       v-loading="loading"
       element-loading-text="页面数据加载中，请稍等...">
    <template v-if="accountObj && accountObj.loginId">
      <div class="side-container" :class="{ 'side-nav-menu': navMenuObj.isShow }" @click.self="hideSideNavMenu">
        <div class="side layout-animate">
          <div class="header">
            <LayoutHeaderLogo :collapsed="navMenuObj.isCollapsed"></LayoutHeaderLogo>
          </div>
          <div class="main">
            <LayoutSide></LayoutSide>
          </div>
        </div>
      </div>
      <WaterMark class="body layout-animate"
                 :disabled="!waterMarkInfo"
                 :text="waterMarkText"
                 v-bind="waterMarkInfo">
        <div class="header">
          <LayoutHeader @refreshCurrentTab="refreshCurrentTab"></LayoutHeader>
          <NetworkNotifier :show-state="hasConnect"
                           :is-connected="isConnected"
                           :connecting="connecting"
                           :try-count="tryCount"
                           :retry-delay="retryDelay"></NetworkNotifier>
        </div>
        <div class="main">
          <LayoutMain ref="main"></LayoutMain>
        </div>
      </WaterMark>
    </template>
  </div>
</template>

<script>
import LayoutHeader from './LayoutHeader'
import LayoutHeaderLogo from './LayoutHeaderLogo'
import LayoutSide from './LayoutSide'
import LayoutMain from './LayoutMain'
import NetworkNotifier from './elements/layout/NetworkNotifier'
import WaterMark from './widgets/WaterMark'
import {mapState, mapMutations, mapActions} from 'vuex'
import routeConfig from '../constants/routeConfig'
import routeUtils from '../util/routeUtils'
import Stomp from '../stomp'
import globalEvent from '../constants/globalEvent'
import {on, off} from 'element-ui/lib/utils/dom'
export default {
  name: 'FrameworkAdminLayout',
  components: {LayoutHeader, LayoutHeaderLogo, LayoutSide, LayoutMain, NetworkNotifier, WaterMark},
  data () {
    return {
      loading: false,
      isConnected: false,
      hasConnect: false,
      connecting: false,
      tryCount: 0,
      retryDelay: 0
    }
  },
  computed: {
    ...mapState({
      navMenuObj: state => state.layout.side.navMenu,
      accountObj: state => state.account
    }),
    waterMarkText () {
      let accountObj = this.accountObj
      if (accountObj) {
        return `${accountObj.loginId} ${accountObj.trueName}`
      }
    },
    waterMarkInfo () {
      let accountObj = this.accountObj
      if (accountObj) {
        let bindInfo = accountObj.bindInfo
        if (bindInfo) {
          return bindInfo.waterMark
        }
      }
    }
  },
  methods: {
    ...mapMutations(['hideSideNavMenu']),
    ...mapMutations(['fullScreenChange']),
    ...mapActions(['setMainActiveTab']),
    ...mapActions(['loadAccount']),
    ...mapMutations(['stompConnected']),
    ...mapMutations(['stompDisconnect']),
    // 加载基础信息
    loadBasicInfo () {
      this.loading = true
      this.loadAccount().then(() => {
        /* 加载布局信息 */
        this.$store.dispatch('loadLayoutFromLocal').then(() => {
          this.setMatchedMainTab(this.$route)
        }).catch(() => {
          this.$notify.error({
            title: '异常信息',
            message: '加载布局信息时出现异常',
            showClose: false
          })
        })
        /* 创建会话 */
        this.createMessageSockJs()
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.loading = false
      })
    },
    setMatchedMainTab: function (route) {
      let matchId = routeUtils.getRouteMatchId(this, route)[0]
      if (matchId) {
        this.setMainActiveTab(matchId).then((success) => {
          if (!success) {
            switch (matchId) {
              case routeConfig.Refresh.path: {
                // 功能页面
                break
              }
              default: {
                this.$notify.warning({
                  title: '提示信息',
                  message: '请从菜单中重新打开功能',
                  showClose: false
                })
                // 如果设置失败则跳转至默认路径
                this.$router.push({ path: '/' })
                break
              }
            }
          }
        })
      }
    },
    refreshCurrentTab: function () {
      let main = this.$refs.main
      if (main) {
        main.refreshCurrentTab()
      }
    },
    createMessageSockJs () {
      this.$bus.$emit(globalEvent.stompClient.CONNECTING)
      this.connecting = true
      Stomp.connect({}, (frame, client) => {
        this.connecting = false
        this.isConnected = true
        this.hasConnect = true
        this.tryCount = 0
        this.stompConnected(client)
        this.$bus.$emit(globalEvent.stompClient.CONNECTED, client)
      }, (frame) => {
        this.connecting = false
        this.isConnected = false
        this.hasConnect = true
        this.stompDisconnect()
        this.$bus.$emit(globalEvent.stompClient.DISCONNECTED)
        // 最多重试时间1分钟
        this.delayForReConnect(Math.min((++this.tryCount) * 5, 60))
      })
    },
    delayForReConnect (delay) {
      this.retryDelay = delay
      setTimeout(() => {
        if (delay > 1) {
          this.delayForReConnect(delay - 1)
        } else {
          this.createMessageSockJs()
        }
      }, 1000)
    },
    installEvent () {
      on(document, 'fullscreenchange', this.fullScreenChange)
      on(document, 'webkitfullscreenchange', this.fullScreenChange)
      on(document, 'mozfullscreenchange', this.fullScreenChange)
      on(document, 'MSFullscreenChange', this.fullScreenChange)
    },
    uninstallEvent () {
      off(document, 'fullscreenchange', this.fullScreenChange)
      off(document, 'webkitfullscreenchange', this.fullScreenChange)
      off(document, 'mozfullscreenchange', this.fullScreenChange)
      off(document, 'MSFullscreenChange', this.fullScreenChange)
    }
  },
  beforeRouteUpdate (to, from, next) {
    next()
    if (routeUtils.getChildRoutePath(this, to) !== routeUtils.getChildRoutePath(this, from)) {
      this.setMatchedMainTab(to)
    }
  },
  created () {
    this.loadBasicInfo()
  },
  mounted () {
    this.installEvent()
  },
  beforeDestroy () {
    this.uninstallEvent()
  }
}
</script>

<style lang="scss">
  .layout-framework-admin {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    &.collapsed {
      & > .side-container {
        & > .side {
          width: 72px;
        }
      }
      & > .body {
        left: 72px
      }
    }
    & > .side-container {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      & > .side {
        position: absolute;
        left: 0;
        top: 0;
        width: 256px;
        bottom: 0;
        box-shadow: 2px 0 6px rgba(0,21,41,.35);
        z-index: 2021;
        & > .header {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          height: 64px;
          line-height: 64px;
        }
        & > .main {
          position: absolute;
          left: 0;
          top: 64px;
          right: 0;
          bottom: 0;
        }
      }
    }
    & > .body {
      position: absolute;
      left: 256px;
      top: 0;
      right: 0;
      height: 100%;
      background-color: #f0f2f5;
      & > .header {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        height: 64px;
        background-color: #fff;
        box-sizing: border-box;
        box-shadow: 0 1px 4px rgba(0,21,41,.08);
        z-index: 2019;
      }
      & > .main {
        position: absolute;
        left: 0;
        top: 64px;
        right: 0;
        bottom: 0;
        background-color: #f0f2f5;
      }
    }
    @media screen and (max-width:767px) {
      & > .side-container {
        background-color: rgba(0,0,0,.5);
        &.side-nav-menu {
          z-index: 2020;
          & > .side {
            box-shadow: 2px 0 6px rgba(0,21,41,.35);
            transform: translateX(0);
          }
        }
        & > .side {
          box-shadow: none;
          transform: translateX(-100%);
        }
      }
      & > .body {
        left: 0!important;
      }
    }
  }
</style>
